import {useEffect} from 'react'
import {withJsonFormsControlProps} from '@jsonforms/react'
import {TextInputField} from '@/components/molecules'

const TextInputComponent = props => {
  /**
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle input change.
   * @property {string} label - Label for the input field.
   * @property {Object} data - Data object for the input field.
   * @property {string} path - Path to the data in the object.
   * @property {Object} errors - Object containing validation errors.
   * @property {Object} schema - JSON schema for the input field.
   * @property {Object} uischema - UI schema for the input field.
   * @property {boolean} required - Indicates if the input field is required.
   * @property {boolean} enabled - Indicates if the input field is enabled.
   * @property {boolean} visible - Indicates if the input field is visible.
   */
  const {handleChange, label, data, path, errors, schema, uischema, required, enabled, visible} = props

  useEffect(() => {
    if (!enabled && data) {
      handleChange(path, '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled])

  const updateValue = (newVal, isValid) => {
    handleChange(path, schema.type === 'string' ? newVal?.trim() : newVal)
    handleChange(path + 'Valid', isValid)
  }

  return (
    <TextInputField
      value={data}
      disabled={!enabled}
      label={uischema.showLabel === false ? '' : label}
      updateValue={updateValue}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      visible={visible}
    />
  )
}

const TextInputControl = withJsonFormsControlProps(TextInputComponent)
export default TextInputControl
